<template>
  <div id="app" :class="[brand, isIframe, appMargin, {'d2d-mode': isD2dPage}]">
    <div class="lang-box" v-if="['Search', 'D2DItinerary', 'D2DSuccess'].indexOf(route) === -1">
      <select class="currency" v-model="currency" aria-label="Select Currency" :disabled="currencyStore.loading || !Object.keys(currencyStore.list).length" v-if="!_route.meta || (_route.meta && !_route.meta.hideCurrency)">
        <option value="USD">$ (USD)</option>
        <option value="INR">{{ currencySymbol.INR }} (INR)</option>
        <option value="CAD">{{ currencySymbol.CAD }} (CAD)</option>
        <option value="EUR">{{ currencySymbol.EUR }} (EUR)</option>
        <option value="GBP">{{ currencySymbol.GBP }} (GBP)</option>
        <option value="JPY">{{ currencySymbol.JPY }} (JPY)</option>
        <option value="CNY">{{ currencySymbol.CNY }} (CNY)</option>
        <option value="AUD">{{ currencySymbol.AUD }} (AUD)</option>
        <option value="AED">{{ currencySymbol.AED }} (AED)</option>
        <option value="MXN">{{ currencySymbol.MXN }} (MXN)</option>
        <option value="PHP">{{ currencySymbol.PHP }} (PHP)</option>
      </select>
    </div>
    
    <div v-if="currentIndex > -1 && bookingType === 'ground'">
      <progress-bar :backLink="backLink" v-if="currentIndex > 0 || route === 'ServiceSelection'"></progress-bar>
    </div>

    <div :class="['row', 'margin-t-l', 'small-margin-t-s _search', appMargin, showOnLoad, montserratFont, {'full-scrn':_route.meta && _route.meta.fullScreen, 'ground-full': _route.meta && _route.meta.groundFull}]">
      <div :class="{
        'dynamic-view': true,
        'columns large-7 padding-r-s medium-padding-h-s': currentIndex > 0 && !$route.meta.isD2d,
        'columns large-12': currentIndex === 0 || route === 'RsvpEdit' || route === 'D2DSuccess'
      }">
        <router-view :user="user" :flash="flash" :cards="cards"
          :leg1="leg1" :leg2="leg2" :backLink="backLink"></router-view>
      </div>
      <div class="large-5 columns padding-l-s medium-padding-h-s" v-if="showPaymentSummary">
        <reservation-details 
          :rerender="rerenderRsvpDetails" v-if="rerenderRsvpDetails && bookingType === 'ground'"
          :flash="flash" :leg1="leg1"
          :leg2="leg2" :user="user" :brand="brand"
        ></reservation-details>
        <payment-summary v-if="bookingType === 'flight'" />
      </div>
    </div>

    <app-loader></app-loader>
    <loader></loader>
    <alert></alert>
    <asap-success></asap-success>
    <logout v-if="global.logout.show"></logout>
    <global-login v-if="authGlobal.show"></global-login>
    <global-signup></global-signup>
    <global-signup-select />
    <global-signup-corporate />
    <redeem-modal v-if="redeemModal"></redeem-modal>
    <user-info v-if="userInfo.show"></user-info>
    <session-modal v-if="sessionModal.show"></session-modal>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')

import Vue from 'vue'
import moment from 'moment-timezone'
import ProgressBar from './components/ProgressBar.vue'
import ReservationDetails from './components/Reservation/ReservationDetails.vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueScrollTo from 'vue-scrollto'
import VueResource from 'vue-resource'
import store from './store'
import ApiQuote from '@/modules/api/quote'
import AppLoader from './components/Global/AppLoader.vue'
import Loader from './components/Global/Loader.vue'
import Alert from './components/Global/Alert'
import logout from './components/Global/Logout'
import paymentSummary from './components/D2DOthers/PaymentSummary.vue'
import WidgetSession from '@/modules/session'
import CreditCard from '@/modules/api/credit-card'
import Credits from '@/modules/api/_credits'
import globalLogin from './components/Global/GlobalLogin'
import globalSignup from './components/Global/GlobalSignup'
import globalSignupSelect from './components/Global/GlobalSignupSelect'
import globalSignupCorporate from './components/Global/GlobalSignupCorporate'
import redeemModal from './components/Global/RedeemModal'
import userInfo from './components/Global/UserInfo'
import sessionModal from './components/Global/SessionModal'
import currencySymbol from '@/data/currency.js'
import AsapSuccess from './components/Global/AsapSuccess'
import serviceSession from '@/modules/api/service-session'

const cookie = require('vue-cookie')

Vue.use(VueResource)
Vue.use(VueScrollTo)

Vue.component('icon', Icon)

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import '@splidejs/splide/dist/css/splide.min.css'
Vue.use(PerfectScrollbar)

Vue.directive('focus', function (el) {
  el.focus();
})

export default {
  props: [ 'brand', 'brandId', 'user', 'flash', 'cards', 'leg1', 'leg2', 'backLink', 'credits' ],
  name: 'app',
  components: {
    'progress-bar': ProgressBar,
    'reservation-details': ReservationDetails,
    AppLoader,
    Loader,
    paymentSummary,
    Alert,
    globalLogin,
    globalSignup,
    globalSignupSelect,
    globalSignupCorporate,
    redeemModal,
    userInfo,
    sessionModal,
    logout,
    AsapSuccess
  },
  data () {
    return {
      showOnLoad: '',
      montserratFont: '',
      _hashDelay: '',
      resendCountdownDelay: '',
      rerenderRsvpDetails: true,
      errorLog: {
        msg: '',
        delay: ''
      },
      session: '',
      currencySymbol: currencySymbol,
      trackSessionDelay: ''
    }
  },
  computed: {
    store () { return this.$store.state },
    isIframe: function () {
      // if (this.brand && this.brand === 's2l' && !!navigator.platform &&
      //   /iPad|iPhone|iPod/.test(navigator.platform)
      // ) {
      //   return 'bounce-fix'
      // }
      return 'medium-margin-t-s'
    },
    currentIndex () { return this.store.currentIndex },
    appMargin () {
      if (this.currentIndex === -1 || this.d2dEnabled) {
        return 'no-margin'
      }
      return ''
    },
    _brandId () { return this.store.brandId },
    route () { return this.$route.name },
    _route () { return this.$route },
    resendReady: {
      get () { return this.$store.state.user.resend.ready },
      set (x) { this.$store.commit('user/setResendReady', x) }
    },
    resendCountdown: {
      get () { return this.$store.state.user.resend.countdown },
      set (x) { this.$store.commit('user/setResendCountdown', x) }
    },
    lang: {
      get () { return this.$i18n.locale },
      set (val) {
        localStorage.setItem('widgetLang', val)
        // this.$i18n.locale = val
        this.$store.commit('setProgressLabel', [
          this.$t('progressbar.chooseRide'),
          this.$t('progressbar.enterDetails'),
          this.$t('progressbar.paymentDetails'),
          this.$t('progressbar.reviewBook')
        ])
        // let url = window.location
        // window.location = url.href.split(url.hash)[0]
        location.reload()
      }
    },
    extraStop () { return this.store.reservation.extraStop.leg1 },
    startErrorLog () { return this.store.other.startErrorLog },
    d2dEnabled () { return CONFIG.featureToggle.d2dBooking },
    isD2dPage () { return this.$route.meta && this.$route.meta.isD2d },
    showPaymentSummary () { return this.$route.meta && this.$route.meta.showPaymentSummary },
    aareservation () { return this.store.reservation },
    booking () { return this.store.booking },
    d2d () { return this.store.reservation.d2d },
    global () { return this.store.global },
    authGlobal () { return this.global.auth },
    redeemModal () { return this.global.redeem.show },
    bookingType () { return this.store.reservation.bookingType },
    currencyStore () { return this.store.other.currency },
    currency: {
      get () { return this.currencyStore.code },
      set (val) {
        // localStorage.setItem('widgetLang', val)
        this.$store.commit('other/setCurrencyData', {code: val})
        this.updateCurrencyValue()

        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            'Flight Booking - Currency',
            {value: val}
          )
        }
      }
    },
    userInfo () { return this.global.userInfo },
    sessionModal () { return this.global.sessionModal },
    _trackSession () { return this.sessionModal.startTracking },
    _appLoader () { return this.store.other.appLoader },
    lyft () { return this.store.reservation.lyft },
    userToken () { return this.store.user.token },
    charter () { return this.$store.state.reservation.charter }
  },
  methods: {
    checkShowOnLoad () {
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack']
      if (brandData) {
        this.montserratFont = brandData.showOnLoad ? 'montserrat' : ''
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
      if (this.route === 'RsvpTrack') {
        document.body.classList.add('widget-full')
        window.dispatchEvent(new HashChangeEvent('hashchange'))
      }
      if (this.$settings.get('TravelInsuranceLabel')) {
        this.$store.commit('setTravelInsuranceLabel', this.$settings.get('TravelInsuranceLabel'))
      }
    },
    startCountdown () {
      let self = this
      if (self.resendCountdownDelay) {
        clearTimeout(self.resendCountdownDelay)
      }
      self.resendCountdownDelay = setTimeout(function () {
        self.resendCountdown--
        if (self.resendCountdown > 0) {
          self.startCountdown()
        } else {
          self.resendReady = true
        }
      }, 1000)
    },
    getQuote () {
      let self = this
      let rsvp = self.$store.state.reservation.leg1
      if (!rsvp.pickup.lat && !rsvp.dropoff.lat) return

      let pickupDate = rsvp.pickupDate || rsvp.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickupDate: pickupDate,
        pickup: { lat: rsvp.pickup.lat, lng: rsvp.pickup.lng },
        dropoff: { lat: rsvp.dropoff.lat, lng: rsvp.dropoff.lng },
        asap: rsvp.isAsap,
        order: 'priority',
        discountCode: self.$store.state.discountCode.code
      }

      quoteData.pickup = rsvp.pickup
      quoteData.dropoff = rsvp.dropoff
      self.extraStop.forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })
      self.$store.commit('reservation/setServiceLoading', true)
      ApiQuote.getQuote2(self, quoteData, (res) => {
        self.$store.commit('reservation/setServiceLoading', false)
        self.rerenderRsvpDetails = false
        self.$nextTick(() => {
          self.$forceUpdate()
          self.rerenderRsvpDetails = true
          self.$root.$emit('showRedeemSuccess', self.$store.state.discountCode.code)
        })
      })
    },
    getCurrencyValue () {
      let self = this
      self.$store.commit('other/setCurrencyData', {loading: true})
      self.$sdk.get(self, 'exchangerate', {}, res => {
        self.$store.commit('other/setCurrencyData', {loading: false})
        if (Object.keys(res).length) {
          self.$store.commit('other/setCurrencyData', {list: res})
        }
        // self.updateCurrencyValue()
      }, '')
    },
    updateCurrencyValue () {
      if (!Object.keys(this.currencyStore.list).length) return
      this.$store.commit('other/setCurrencyData', {
        symbol: currencySymbol[this.currency],
        value: this.currencyStore.list[this.currency]
      })
      localStorage.setItem('widgetCurrency', JSON.stringify({
        code: this.currencyStore.code,
        symbol: this.currencyStore.symbol,
        value: this.currencyStore.value,
        list: this.currencyStore.list
      }))
    },
    updateServiceSession () {
      let token = this.$store.state.user.token
      let rsvp = this.$store.state.reservation
      let roundtrip = rsvp.isRoundtrip
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      if (!token || !leg1.selectedService || this.charter.enabled || leg1.isAsap) return

      // _isRoundtrip
      let priceType = !roundtrip ? 'prices' : 'roundtrip'
      if (this.lyft.enabled || this.lyft.enabledLeg2) priceType = 'prices'
      let legs = [
        {
          amount: leg1.services[leg1.selectedService][priceType][leg1.passenger - 1].price,
          serviceTypeId: leg1.services[leg1.selectedService].id,
          airportFee: leg1.services[leg1.selectedService].airportFee || 0,
          gasFee: leg1.services[leg1.selectedService].gasFee || 0,
          travelInsurance: leg1.services[leg1.selectedService].travelInsurance || 0
        },
        null
      ]
      if (roundtrip && leg2.selectedService) {
        legs[1] = {
          amount: leg2.services[leg2.selectedService][priceType][leg2.passenger - 1].price,
          serviceTypeId: leg2.services[leg2.selectedService].id,
          airportFee: leg2.services[leg2.selectedService].airportFee || 0,
          gasFee: leg2.services[leg2.selectedService].gasFee || 0,
          travelInsurance: leg2.services[leg2.selectedService].travelInsurance || 0
        }
      }

      serviceSession.sendSession(this, {
        token: token,
        brandId: this.$store.state.brandId,
        deviceType: 'ww',
        legs: legs
      }, res => {
        // console.log('cb', res)
      }, '/')
    }
  },
  watch: {
    credits (val) {
      this.$store.commit('setCredits', val)
    },
    user (val) {
      if (val && (val.mobile || val.phone)) {
        this.user.countryCode = val.countryCode || val.dialCode
        this.user.phone = val.phone || val.mobile

        this.$store.commit('user/setToken', cookie.get('userToken'))
        this.$store.commit('user/setUserInfo', val)
        this.$store.commit('user/setAda', {
          serviceDog: val.ada ? val.ada.serviceDog === 1 : false,
          wheelChairLift: val.ada ? val.ada.wheelChairLift === 1 : false
        })
        this.$store.commit('user/setLoginAda', {
          serviceDog: val.ada ? val.ada.serviceDog === 1 : false,
          wheelChairLift: val.ada ? val.ada.wheelChairLift === 1 : false
        })
      }
    },
    brandId (value) {
      this.$store.commit('setBrand', this.brandId)
      this.$store.commit('setBrandCode', this.brand)
      this.checkShowOnLoad()
    },
    _brandId: function (value) {
      this.$store.commit('setBrand', value)
      this.checkShowOnLoad()
    },
    route (value) {
      let self = this
      this.rerenderRsvpDetails = false
      self.$nextTick(() => {
        self.$forceUpdate()
        self.rerenderRsvpDetails = true
      })
      if (value === 'Search') {
        if (self.trackSessionDelay) clearTimeout(self.trackSessionDelay)
      }

      this.checkShowOnLoad()
      if (this.$route.path === '/') {
        this.$router.push('search')
      }
    },
    _route (val) {
      if (val.meta && val.meta.isD2d) {
        let body = document.querySelector('body')
        if (!body.classList.contains('widget-full')) {
          body.classList.add('widget-full')
        }
      }
    },
    resendReady (x) {
      let self = this
      if (!x) {
        self.resendCountdown = this.$store.state.user.resend.cooldown
        self.startCountdown()
      }
    },
    startErrorLog (val) {
      let self = this
      if (val) {
        window.addEventListener('error', (event) => {
          self.errorLog.msg += `[${moment().format('MM-DD-YYYY hh:mmA')}] ${event.type}: ${event.message} ------`
          if (self.errorLog.delay) {
            clearTimeout(self.errorLog.delay)
          }
          self.errorLog.delay = setTimeout(function () {
            // self.$sdk.opt('/quotation/time', {
            //   token: self.store.user.token,
            //   brandId: self.store.brandId,
            //   quotationId: 999,
            //   responseTime: 1,
            //   deviceType: 'test',
            //   data: {
            //     msg: self.errorLog.msg
            //   }
            // }, res => {
            //   self.errorLog.msg = ''
            //   if (res.error) console.log('ERROR quotation time')
            // })
          }, 3000)
        })
      }
    },
    _trackSession (val) {
      let self = this
      if (val) {
        self.$store.commit('global/setSessionModalData', {
          startTracking: false,
          isOnGoing: true
        })
        if (self.trackSessionDelay) clearTimeout(self.trackSessionDelay)
        self.trackSessionDelay = setTimeout(function () {
          if (['D2DItinerary', 'D2DPaxForm', 'Payment', 'D2DReview'].indexOf(self.$route.name) > -1) {
            if (self.$route.name === 'D2DReview' && self.d2d.processingFlightSubmit) return
            self.$store.commit('global/setSessionModalData', {
              show: true,
              isOnGoing: false
            })
          }
        }, (self.d2d.settings.sessionTimeout * 1000) - (self.d2d.settings.sessionShowWarning * 1000))
      }
    },
    _appLoader (x) {
      if (!x) this.$store.commit('other/setOtherData', {useLoadingMsg: false})
    },
    'lyft.enabled': function (val) {
      if (val) this.$store.commit('setTipAmount', 0)
    },
    'lyft.enabledLeg2': function (val) {
      if (val) this.$store.commit('setTipAmount', 0)
    },
    userToken () {
      this.updateServiceSession()
    }
  },
  store,
  created () {
    let self = this
    window.addEventListener('hashchange', function () {
      if (self._hashDelay) {
        clearTimeout(self._hashDelay)
      }
      self._hashDelay = setTimeout(function () {
        if (window.location.hash.indexOf('#/service') > -1 ||
          window.location.hash.indexOf('#/rsvp-edit') > -1
        ) {
          document.body.classList.add('widget-full')
          window.dispatchEvent(new HashChangeEvent('hashchange'))
        }
      }, 100)
    }, false)

    self.$store.commit('booking/setSettingsData', {customFlight: !CONFIG.featureToggle.d2dRoundtripAPI})
    if (self.$store.state.reservation.sharedAllowedTime.start === '') {
      request.get({
        url: CONFIG.Gateway.url + '/appsettings',
        json: true
      }, function (err, res, body) { // eslint-disable-line handle-callback-err
        self.$store.commit('setTravelInsuranceLabel', body.TravelInsuranceLabel)
        self.$store.commit('reservation/setDriverResponseTime', parseInt(body.DriverResponseTime))
        self.$store.commit('reservation/setWebTimeBuffer', parseInt(body.WebTimeBuffer))
        self.$store.commit('reservation/setSharedAllowedTime', {
          start: body.AirportStart,
          end: body.AirportEnd
        })
        self.$store.commit('reservation/setOptinAllowedTime', {
          start: body.OptinAirportStart,
          end: body.OptinAirportEnd
        })
        self.$store.commit('user/setResendCooldown', parseInt(body.SMSVerificationTimer))
        self.$store.commit('reservation/setCharterData', {
          MilitaryTimeWidget: body.MilitaryTimeWidget,
          globalEnabled: body.CharterEnabled === 1,
          maxDuration: body.CharterMaxDuration
        })
        self.$store.commit('reservation/setMtechData', {
          markup: {
            type: body.MTechMarkupType,
            value: body.MTechMarkupValue
          }
        })
        self.$store.commit('booking/setSettingsData', {
          timeBuffer: body.D2DTimeBuffer,
          markUpPercent: body.D2DMarkupPercent,
          arrivalBufferDomestic: body.D2DArrivalDomesticSuggestedMins,
          arrivalBufferInternational: body.D2DArrivalInternationalSuggestedMins,
          departureBufferDomestic: body.D2DDepartureDomesticSuggestedMins,
          departureBufferInternational: body.D2DDepartureInternationalSuggestedMins,
          nearByAirportMilesLimit: body.D2DAirportDistanceLimitMiles,
          groundLeg1Discount: body.D2DGroundLeg1Discount,
          groundLeg2Discount: body.D2DGroundLeg2Discount,
          groundLeg3Discount: body.D2DGroundLeg3Discount,
          groundLeg4Discount: body.D2DGroundLeg4Discount,
          groundLeg1: {
            free: body.D2DGroundLeg1Discount === 100 && body.D2DGroundLeg1DiscountType === '%',
            value: body.D2DGroundLeg1Discount,
            currency: body.D2DGroundLeg1DiscountType
          },
          groundLeg2: {
            free: body.D2DGroundLeg2Discount === 100 && body.D2DGroundLeg2DiscountType === '%',
            value: body.D2DGroundLeg2Discount,
            currency: body.D2DGroundLeg2DiscountType
          },
          groundLeg3: {
            free: body.D2DGroundLeg3Discount === 100 && body.D2DGroundLeg3DiscountType === '%',
            value: body.D2DGroundLeg3Discount,
            currency: body.D2DGroundLeg3DiscountType
          },
          groundLeg4: {
            free: body.D2DGroundLeg4Discount === 100 && body.D2DGroundLeg4DiscountType === '%',
            value: body.D2DGroundLeg4Discount,
            currency: body.D2DGroundLeg4DiscountType
          },
          requirePhone: body.D2DPhoneRequire,
          sessionTimeout: body.D2DSessionTimeoutSecs,
          sessionShowWarning: body.D2DSessionWarningSecs,
          forceGroundMiles: body.D2DForceGroundMiles || 0
        })
        self.$store.commit('other/setOtherData', {
          hereMapsRouteDelay: body.HereMapsRouteDelay || 10
        })
        // self.$store.commit('booking/setDepartureData', {
        //   date: moment().add(body.D2DTimeBuffer, 'minutes').add(2, 'days').format('MM/DD/YYYY'),
        //   return: moment().add(body.D2DTimeBuffer, 'minutes').add(9, 'days').format('MM/DD/YYYY'),
        //   isReturning: true
        // })
      })
    }
  },
  mounted () {
    if (this.brandId) { this.$store.commit('setBrand', this.brandId) }
    if (this.brand) { this.$store.commit('setBrandCode', this.brand) }

    this.getCurrencyValue()
    if (localStorage.getItem('widgetCurrency')) {
      let data = localStorage.getItem('widgetCurrency')
      this.$store.commit('other/setCurrencyData', JSON.parse(data))
    }

    if (localStorage.getItem('widgetLang')) {
      this.$i18n.locale = localStorage.getItem('widgetLang')
      this.$store.commit('setProgressLabel', [
        this.$t('progressbar.chooseRide'),
        this.$t('progressbar.enterDetails'),
        this.$t('progressbar.paymentDetails'),
        this.$t('progressbar.reviewBook')
      ])
    }

    let firstVisit = localStorage.getItem('firstVisitData')
    if (firstVisit) {
      firstVisit = JSON.parse(firstVisit)
      this.$store.commit('user/setFirstVisitData', {
        countryCode: firstVisit.countryCode,
        mobile: firstVisit.mobile
      })
    }

    let self = this
    self.$root.$on('redeemCodeSuccess', function (res) {
      if (res.type === 'discount') {
        self.$store.commit('discountCode/setDiscountData', {
          id: res.data.id,
          code: res.data.code,
          type: res.data.type,
          amount: res.data.amount,
          start: res.data.start,
          end: res.data.end
        })
        self.getQuote()
      }
    })
    self.$root.$on('logoutSuccess', function () {
      self.$store.commit('discountCode/setDiscountData', {
        id: '',
        code: '',
        type: '',
        amount: '',
        start: '',
        end: ''
      })
      self.getQuote()
    })

    self.session = new WidgetSession(self)
    let token = cookie.get('userToken')
    if (token) {
      self.$sdk.get(self, '/me', {token: token}, res => {
        if (res.error) return

        self.session.useToken(token) // Only save the token if successful
        self.$store.commit('user/setToken', token)
        res.bday = res.dateOfBirth
        res.country = res.userCountry
        res.passportNum = res.passportNum
        if (res.paxinfo) {
          res.title = res.paxinfo.title
          res.gender = res.paxinfo.gender
          self.$store.commit('user/setUserData', {
            address: res.paxinfo.address || '',
            city: res.paxinfo.city || '',
            zip: res.paxinfo.zip || ''
          })
        }
        self.$store.commit('user/setUserInfo', res)
        Credits.get(self, {token: token}, () => {
          // ..
        })
        CreditCard.getCards(self, token, r => {
          if (r.error) {
            console.log('error getting cc', r.error)
          }
        })
      })
    }

    // let isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    // if (this.brand === 'dd' && isMobile) {
    //   window.location.replace('https://gateway.opoli.com/applink/dd')
    // }
  }
}
</script>

<style lang="scss">
$screen-small: 40em;
html{
  scroll-behavior: smooth;
}
body{
  background-color: #f00;

  &.widget-no-scroll, &.widget-full.filter-open{ overflow:hidden; }
}

#app {
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  // padding-top: 30px;
  min-height: 100%;
  font-family: 'Questrial', sans-serif;

  h1, h2:not(.font-fix), h3, h4{ font-family: 'Questrial', sans-serif!important; }
  &.bounce-fix{
    margin-top:0;
    padding-top: 20px;
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling:touch;

    input[type=text]{
      webkit-user-select: text;
      -khtml-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
    }
  }
  &.d2d-mode{
    background: #f1f3f6;
  }
  .row{
    // max-width: 62.5rem;
    max-width: 1200px;
  }
  ._search{ padding-top: 20px; }
  ._search.show-on-load{ max-width: 100%!important }
  .full-scrn{
    max-width: 1300px!important;
    position: relative;
    padding: 0 10px;
  }
  .ground-full{
    max-width: 1000px!important;
    position: relative;
  }
  .show-on-load{
    .dynamic-view{ width: 100%; }
  }
  .right, .left{
    transform: rotate(0)!important;
  }
}

.card{
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  border: 1px solid rgba(0,0,0,0.2);
  padding: 20px;
}

.lang-box{
  text-align: right;
  padding: 10px 0;

  label{
    display: inline-block;
    margin-right: 5px;
    color: #777;
  }

  select{
    width: 100px;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-right: 10px;
    font-size: 13px;
    color: #555;
  }
  .currency{
    width: auto;
  }
}

.widget-full .carousel.slide.main-banner-carousel{
  display: none;
}

.no-margin { margin-top: 0 !important; }
.discount-img{
  background: url(/img/discount.8f4bfd7.svg) no-repeat;
  width: 15px;
  height: 15px;
  display: inline-block;
  background-size: contain;
  margin-right: 3px;
  vertical-align: -3px;
}

@font-face {
  font-family: 'opoli';
  src: url("assets/fonts/opoli.eot?y08y5r");
  src: url("assets/fonts/opoli.eot?y08y5r#iefix") format("embedded-opentype"), url("assets/fonts/opoli.ttf?y08y5r") format("truetype"), url("assets/fonts/opoli.woff?y08y5r") format("woff"), url("assets/fonts/opoli.svg?y08y5r#icomoon") format("svg");
  font-weight: normal;
  font-style: normal
}
@font-face {
  font-family: 'pts';
  src: url("assets/fonts/pts.eot?1k5nh7");
  src: url("assets/fonts/pts.eot?1k5nh7#iefix") format("embedded-opentype"), url("assets/fonts/pts.ttf?1k5nh7") format("truetype"), url("assets/fonts/pts.woff?1k5nh7") format("woff"), url("assets/fonts/pts.svg?y08y5r#icomoon") format("svg");
  font-weight: normal;
  font-style: normal
}
@font-face {
  font-family: 's2l';
  src: url("assets/fonts/s2l.eot?1k5k71");
  src: url("assets/fonts/s2l.eot?1k5k71#iefix") format("embedded-opentype"), url("assets/fonts/s2l.ttf?1k5k71") format("truetype"), url("assets/fonts/s2l.woff?1k5k71") format("woff"), url("assets/fonts/s2l.svg?1k5k71#icomoon") format("svg");
  font-weight: normal;
  font-style: normal
}
.icon-font{
  font-size: 50px;
  text-align: center;
  display: block;
  margin-bottom: 20px;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &:before{
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
  }
}

.opoli-logo{
  font-family: 'opoli'!important;
  &:before{ content: "\e901"; }
}
.pts-logo{
  font-family: 'pts'!important;
  &:before{ content: "\e900"; }
}
.s2l-logo{
  font-family: 's2l'!important;
  &:before{ content: "\e900"; }
}

@media only screen and (max-width: $screen-small) {
  .lang-box{
    padding: 10px 0 0!important;
  }
}

@import "assets/scss/General.scss";
@import "assets/scss/brands/d2d.scss";
@import "assets/scss/FormField.scss";
@import "assets/scss/FormFieldError.scss";
@import "assets/scss/Buttons.scss";
@import "assets/scss/MobileResponsive.scss";
@import "assets/scss/Modal.scss";
</style>



// WEBPACK FOOTER //
// App.vue?d3ea8612